module.exports = ".success-color {\r\n    color: green;\r\n}\r\n\r\n.error-color {\r\n    color: red;\r\n}"